/**
 * Case Schema Version Context
 *
 * Case-detail pages provide the case's nomos schema major (see
 * caseSchemaVersion) so SchemaProvider, mounted deep inside field components,
 * renders the case with the schema it was written under. Outside a case page
 * there is no provider and the workflow's current schema is used.
 */

import React, { createContext, useContext } from 'react';

const CaseSchemaVersionContext = createContext<string | undefined>(undefined);

interface CaseSchemaVersionProviderProps {
  schemaVersion: string | undefined;
  children: React.ReactNode;
}

export const CaseSchemaVersionProvider: React.FC<CaseSchemaVersionProviderProps> = ({
  schemaVersion,
  children,
}) => (
  <CaseSchemaVersionContext.Provider value={schemaVersion}>
    {children}
  </CaseSchemaVersionContext.Provider>
);

export function useCaseSchemaVersion(): string | undefined {
  return useContext(CaseSchemaVersionContext);
}
